export default __webpack_public_path__ + "static/media/arrow-down.97d78898.svg";